import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export class HttpError extends Error {
  constructor(message: string, public statusCode: number) {
    super(message);
  }
}

@Injectable({
  providedIn: 'root',
})
export class StateService {
  public statusError: BehaviorSubject<any>;

  constructor() {
    this.statusError = new BehaviorSubject<any>(null);
  }

  public gotUnauthorizedError(err: HttpError) {
    this.statusError.next(err);
  }

  public gotForbiddenError(err: HttpError) {
    this.statusError.next(err);
  }
}
